<template>
  <div class="header-with-navigation-below" id="header">
    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500&display=swap" rel="stylesheet">
    <div class="hidden-xs hidden-sm">
      <header data-collapsible="false" id="desktop-header">
        <div class="header-content">
          <div class="row">
            <div class="col-sm-4">
              <a href="#"
                ><img
                  alt="Dealer"
                  class="dealer-logo"
                  :src="[!logoURL ? images.logoExample[0] : logoURL]"
                  title="Dealer"
              /></a>
            </div>
            <div class="col-sm-5">
              <div class="search-bar">
                <form action="/vehicles" role="search">
                  <div class="input-group">
                    <input
                      aria-label="Search Bar"
                      autocomplete="off"
                      autocorrect="off"
                      class="form-control input-search"
                      data-custom="false"
                      data-placement="bottom"
                      data-search-suggestions="true"
                      data-suggest="true"
                      data-top="2021 Brand Tundra 2WD"
                      name="query"
                      placeholder="Search this site..."
                      spellcheck="false"
                      title="Search this site..."
                      type="text"
                      value=""
                    /><span class="input-group-btn"
                      ><button
                        aria-label="search text"
                        class="btn btn-default no-border-left"
                        type="submit"
                      >
                        <i
                          aria-hidden="true"
                          class="fa fa-search"
                        ></i></button
                      ><span
                        aria-label="pause automatic search suggest"
                        aria-pressed="false"
                        class="btn btn-default toggleSearchText visuallyhidden"
                        role="button"
                        tabindex="0"
                        ><i aria-hidden="true" class="fa fa-pause"></i></span
                    ></span>
                  </div>
                </form>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="phone">
                <h3 class="text-right">
                  <span>Sales &amp; Service</span><br /><a
                    class="track-click dynamic-phone-number sales-phone ws-dynamic-number"
                    data-action="Sales"
                    data-adsolconv="call_initiated"
                    data-category="Click to Call"
                    data-label="Desktop"
                    data-number-type="sales"
                    href="#"
                    >(123) 456-7890</a
                  >
                </h3>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="navigation-content">
        <nav class="navbar nav-right nav-no-border">
          <div class="navigation-container">
            <div class="collapse navbar-collapse">
              <ul
                class="nav navbar-nav navbar-left"
                data-more-dropdown="false"
              >
                <li role="none">
                  <a href="#" role="menuitem" target="">Home</a>
                </li>
                <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
                  <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-section-title="New Vehicles" data-toggle="dropdown" href="#" role="menuitem" target="">New Vehicles</a>
                  <ul aria-label="New Vehicles" class="dropdown-menu" role="menu">
                    <li role="none"><a href="#" role="menuitem" target="">Browse Inventory</a></li>
                    <li role="none"><a href="#" role="menuitem" target="">Schedule Test Drive</a>
                    </li>
                    <li role="none"><a href="#" role="menuitem" target="">Quick Quote</a></li>
                    <li role="none"><a href="#" role="menuitem" target="">Trade In Evaluation</a>
                    </li>
                    <li role="none"><a href="#" role="menuitem" target="">Shop Our Ads</a></li>
                  </ul>
                </li>
                <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
                  <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-section-title="Pre-Owned Vehicles" data-toggle="dropdown" href="#" role="menuitem" target="">Pre-Owned Vehicles</a>
                  <ul aria-label="Pre-Owned Vehicles" class="dropdown-menu" role="menu">
                    <li role="none"><a href="#" role="menuitem" target="">Browse Inventory</a></li>
                    <li role="none"><a href="#" role="menuitem" target="">Vehicles Under $12,000</a>
                    </li>
                    <li role="none"><a href="#" role="menuitem" target="">Locate Your Vehicle</a>
                    </li>
                    <li role="none"><a href="#" role="menuitem" target="">Trade In Evaluation</a>
                    </li>
                  </ul>
                </li>
                <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
                  <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-section-title="Specials" data-toggle="dropdown" href="#" role="menuitem" target="">Specials</a>
                  <ul aria-label="Specials" class="dropdown-menu" role="menu">
                    <li role="none"><a href="#" role="menuitem" target="">New Vehicle Specials</a></li>
                    <li role="none"><a href="#" role="menuitem" target="">Pre-Owned Specials</a></li>
                  </ul>
                </li>
                <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
                  <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-section-title="Financing" data-toggle="dropdown" href="#" role="menuitem" target="">Financing</a>
                  <ul aria-label="Financing" class="dropdown-menu" role="menu">
                    <li role="none"><a href="#" role="menuitem" target="">Finance Information</a></li>
                    <li role="none"><a href="#" role="menuitem" target="">Finance Application</a></li>
                  </ul>
                </li>
                <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
                  <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-section-title="Service &amp; Parts" data-toggle="dropdown" href="#" role="menuitem" target="">Service &amp; Parts</a>
                  <ul aria-label="Service &amp; Parts" class="dropdown-menu" role="menu">
                    <li role="none"><a href="#" role="menuitem" target="">Service Info</a></li>
                    <li role="none"><a href="#" role="menuitem" target="">Service Appointments</a></li>
                    <li role="none"><a href="#" role="menuitem" target="">Service Coupons</a></li>
                    <li role="none"><a href="#" role="menuitem" target="">Parts Request</a></li>
                  </ul>
                </li>
                <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
                  <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown" data-model-dropdown="" data-section-title="About" data-toggle="dropdown" href="#" role="menuitem" target="">About</a>
                  <ul aria-label="About" class="dropdown-menu" role="menu">
                    <li role="none"><a href="#" role="menuitem" target="">Reviews</a></li>
                    <li role="none"><a href="#" role="menuitem" target="">Career Opportunities</a></li>
                    <li role="none"><a href="#" role="menuitem" target="">Staff Directory</a></li>
                  </ul>
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target="">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
    <div class="visible-sm visible-xs">
      <div class="mobile-contact-bar navbar">
        <div class="toggle-side-menu">
          <a class="mobile-menu-toggle" @click="toggleSideNav">
            <span class="icon-label">MENU</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </a>
        </div>
        <div class="mobile-dealer-logo pull-left">
          <a href="#">
            <img alt="Logo" class="dealer-logo"
            :src="[!logoURL ? images.logoExample[0] : logoURL]"
              title="Logo">
          </a>
        </div>
        <div class="contact-info">
          <div class="contact-item mobile-sales-phone" id="toggle-click-to-call">
            <i class="fa fa-phone"></i>
            <a class="hidden-xs" href="#"></a>
          </div>
          <a class="contact-item mobile-get-directions"
            data-action="Address Click" data-category="Hours &amp; Directions" data-label="Dealership Address Link"
            href="#" itemprop="hasMap">
            <i aria-hidden="true" class="fa fa-map-marker"></i>
            <span class="hidden-xs">Directions</span>
          </a>
        </div>
      </div>
      <div class="mobile-nav-bar sidr left" id="sidr" role="navigation" style="transition: left 0.2s ease 0s;" v-if="sideNavOpen">
        <div class="navbar-inner nav navbar-nav">
          <ul class="side-nav" role="menu">
            <div class="search-bar">
              <form action="/vehicles" role="search">
                <div class="input-group">
                  <input aria-label="Search Bar" autocomplete="off" autocorrect="off" class="form-control input-search" data-custom="false" data-placement="bottom" data-search-suggestions="true" data-suggest="true" data-top="" name="query" placeholder="Search this site..." spellcheck="false" title="Search this site..." type="text" value="">
                  <span class="input-group-btn">
                    <button aria-label="search text" class="btn btn-default no-border-left" type="submit">
                      <i aria-hidden="true" class="fa fa-search"></i>
                    </button>
                  </span>
                </div>
              </form>
            </div>
            <li role="none">
              <a href="#" role="menuitem" target="">Home</a>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#new-vehicles" aria-expanded="false" aria-controls="new-vehicles">New Vehicles</a>
              <ul id="new-vehicles" aria-label="New Vehicles" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Browse Inventory</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Schedule Test Drive</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Quick Quote</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Trade In Evaluation</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Shop Our Ads</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#pre-owned-vehicles" aria-expanded="false" aria-controls="pre-owned-vehicles">Pre-Owned Vehicles</a>
              <ul id="pre-owned-vehicles" aria-label="Pre-Owned Vehicles" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Browse Inventory</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Vehicles Under $12,000</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Locate Your Vehicle</a>
                </li>
                <li role="none"><a href="#" role="menuitem" target="">Trade In Evaluation</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#specials" aria-expanded="false" aria-controls="specials">Specials</a>
              <ul id="specials" aria-label="Specials" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">New Vehicle Specials</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Pre-Owned Specials</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#financing" aria-expanded="false" aria-controls="financing">Financing</a>
              <ul id="financing" aria-label="Financing" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Finance Information</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Finance Application</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#service" aria-expanded="false" aria-controls="service">Service &amp; Parts</a>
              <ul id="service" aria-label="Service &amp; Parts" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Service Info</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Service Appointments</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Service Coupons</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Parts Request</a></li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a role="button" data-toggle="collapse" href="#about" aria-expanded="false" aria-controls="about">About</a>
              <ul id="about" aria-label="About" class="collapse" role="menu">
                <li role="none"><a href="#" role="menuitem" target="">Reviews</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Career Opportunities</a></li>
                <li role="none"><a href="#" role="menuitem" target="">Staff Directory</a></li>
              </ul>
            </li>
            <div class="close-mobile-wrap" @click="closeSideNav">
              <span class="close-mobile-nav">
                <i class="fa fa-close">&nbsp;</i>
                <span>close</span>
              </span>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images', 'logoURL'],
  data() {
    return {
      sideNavOpen: false,
    };
  },
  mounted() {},
  methods: {
    addOpen: function(e) {
      e.target.classList.add("open");
    },
    removeOpen: function(e) {
      e.target.classList.remove("open");
    },
    toggleSideNav: function() {
      this.sideNavOpen = !this.sideNavOpen;
    },
    closeSideNav: function() {
      this.sideNavOpen = false;
    },
  },
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.header-with-navigation-below {
  background: #fff;
  color: var(--primary-dark);
  width: 100%;
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-weight: 400;
  font-size: 16px;
  -webkit-box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.3);
}
.header-with-navigation-below header {
  padding-top: 10px;
  background: #fff;
}
.header-with-navigation-below .header-content {
  padding-left: 15px;
  padding-right: 15px;
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
}
.header-with-navigation-below .header-content,
.header-with-navigation-below .navigation-container {
  max-width: 1400px;
  margin: 0 auto;
}
.header-with-navigation-below .phone {
  color: var(--secondary-dark);
  text-transform: capitalize;
}
.header-with-navigation-below .phone a {
  color: var(--primary-color);
}
.header-with-navigation-below #desktop-header .search-bar {
  padding: 6px 0 0;
  display: inline-block;
  width: 95%;
  position: relative;
}
.header-with-navigation-below #desktop-header .search-bar .input-group input,
.header-with-navigation-below #desktop-header .search-bar .input-group .input-group-btn .btn {
  background: #fff;
  height: 50px;
  width: 100%;
}
.header-with-navigation-below #desktop-header .search-bar .input-group input {
  color: #000;
  font-size: 18px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.header-with-navigation-below #desktop-header .search-bar .input-group .input-group-btn .btn {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.header-with-navigation-below #desktop-header .search-bar .input-group .input-group-btn .btn:hover {
  opacity: .7;
}
.header-with-navigation-below .navigation-content {
  height: 50px;
  line-height: 50px;
  font-weight: 300;
  background: var(--primary-color);
}
.header-with-navigation-below .navigation-content .navbar-nav > li {
  font-size: 16px;
}
.header-with-navigation-below .navigation-content .navbar-nav > li > a {
  height: 50px;
  color: #fff;
  text-shadow: none;
  transition: all 0.3s ease-in-out;
  background: transparent;
}
.header-with-navigation-below .navigation-content .navbar-nav > li > a:hover {
  background: transparent;
  color: #fff;
  cursor: pointer;
}
.header-with-navigation-below .navigation-content .navbar-nav > li > a:after {
  display: block;
  content: " ";
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 0;
  transition: all 0.3s ease-in-out;
  height: 3px;
  background-color: #fff;
}
.header-with-navigation-below .navigation-content .navbar-nav > li > a:hover::after, .header-with-navigation-below .navigation-content .navbar-nav > li > a:focus::after, .header-with-navigation-below .navigation-content .navbar-nav > li.open > a:after {
  width: 100%;
  left: 0%;
}
.header-with-navigation-below .navigation-content .navbar-nav .open > a {
  height: 50px;
  text-shadow: none;
  transition: all 0.3s ease-in-out;
  background: transparent;
}
.header-with-navigation-below .navigation-content .navbar-nav .open > a:after {
  display: block;
  content: " ";
  position: absolute;
  width: 100%;
  left: 0%;
  bottom: 0;
  width: 0;
  height: 3px;
  background-color: #fff;
}
.header-with-navigation-below .navigation-content .navbar-nav > li {
  min-height: 50px;
}
.header-with-navigation-below .navigation-content .navbar-nav > li .dropdown-menu {
  margin-top: -1px;
  padding: 0;
}
.collapse.navbar-collapse {
  text-align: center;
}
.navbar-nav {
  float: none !important;
  display: inline-block;
}
.navbar-nav .header-with-navigation-below .navigation-content .navbar-nav > li .dropdown-menu > li {
  height: 40px;
  line-height: 40px;
  margin: 0;
}
.header-with-navigation-below .navigation-content .navbar-nav > li .dropdown-menu > li > a {
  height: 40px;
  line-height: 40px;
  padding: 0 5px;
  margin: 0;
}
.header-with-navigation-below .navigation-content .navbar-nav > li .dropdown-menu > li > a:hover {
  background: #f5f5f5;
  color: var(--primary-color);
  cursor: pointer;
}
.header-with-navigation-below .mobile-contact-bar {
  height: 70px;
  background: #fff;
  margin-bottom: 0;
  left: 0;
  top: 0;
  width: 100%;
}
.header-with-navigation-below .mobile-contact-bar .mobile-dealer-logo img {
  padding: 10px;
}
.header-with-navigation-below .mobile-contact-bar .mobile-menu-toggle {
  width: 60px;
  height: 70px;
  padding: 25px 15px;
  float: left;
  background: transparent;
}
.header-with-navigation-below .mobile-contact-bar .mobile-menu-toggle .icon-bar {
  display: block;
  margin-top: 4px;
  width: 30px;
  height: 3px;
  border-radius: 1px;
  background-color: var(--primary-color);
}
.header-with-navigation-below .mobile-contact-bar .mobile-menu-toggle
  .icon-label {
  display: none;
}
.header-with-navigation-below .mobile-contact-bar .contact-info {
  float: right;
  margin-top: 18px;
  margin-right: 12px;
}
.header-with-navigation-below .mobile-contact-bar .contact-info .contact-item {
  display: inline-block;
  vertical-align: middle;
  color: var(--primary-color);
  letter-spacing: 0.05em;
  margin-right: 6px;
  font-size: 25px;
  font-weight: 600;
}
.header-with-navigation-below .mobile-contact-bar .contact-info .contact-item:hover {
  text-decoration: none;
  cursor: pointer;
}
.header-with-navigation-below .mobile-contact-bar .contact-info .contact-item .fa {
  margin-right: 0.1em;
}
.header-with-navigation-below .mobile-contact-bar .contact-info .contact-item a {
  color: inherit;
}
.header-with-navigation-below .mobile-contact-bar .contact-info .contact-item a:hover {
  text-decoration: inherit;
}
.header-with-navigation-below .mobile-nav-bar .side-nav {
  border-bottom: none;
}
.header-with-navigation-below .mobile-nav-bar .search-bar {
  border: 1px solid #4d4d4d;
}
.header-with-navigation-below .mobile-nav-bar .search-bar form {
  margin: 0;
}
.header-with-navigation-below .mobile-nav-bar .search-bar .input-search {
  margin: 0;
  padding: 5;
  height: 40px;
}
.header-with-navigation-below .mobile-nav-bar .search-bar .input-group-btn {
  padding: 0;
}
.header-with-navigation-below .mobile-nav-bar .search-bar .input-group-btn
  button {
  height: 40px;
}
.header-with-navigation-below .mobile-nav-bar .side-nav > li {
  display: block;
  float: left;
  width: 100%;
  border-bottom: 1px solid #333;
}
.header-with-navigation-below .mobile-nav-bar .side-nav > li > a,
.header-with-navigation-below .mobile-nav-bar .navbar-inner > ul > li.dropdown.open > a {
  background: #222;
  color: #fff;
  display: block;
  height: 40px;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 15px;
  color: #fff;
  white-space: nowrap;
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  text-transform: none;
  margin: 0;
}
.header-with-navigation-below .mobile-nav-bar .side-nav > li > a:hover,
.header-with-navigation-below .mobile-nav-bar .navbar-inner > ul > li.dropdown.open > a:hover {
  background: #1c1c1c;
}
.header-with-navigation-below .mobile-nav-bar .side-nav > li > ul.dropdown-menu {
  width: 100%;
  left: 0;
  display: none;
  position: relative;
}
.visuallyhidden {
  display: none;
}
.header-with-navigation-below .mobile-nav-bar .side-nav > li > ul.dropdown-menu > li > a {
  height: 40px;
  line-height: 40px;
  background: #444;
  font-size: 14px;
  color: #fff;
  text-align: left;
  float: left;
  min-width: 100%;
  position: relative;
  border-bottom: 1px solid #333;
}
.header-with-navigation-below .mobile-nav-bar .side-nav > li > ul.dropdown-menu > li > a:hover {
  background: #333;
}
.header-with-navigation-below .mobile-nav-bar .close-mobile-wrap {
  text-align: right;
  padding: 10px 15px;
}
.header-with-navigation-below .mobile-nav-bar .close-mobile-wrap .close-mobile-nav {
  color: #aaa;
}
.header-with-navigation-below .mobile-nav-bar .close-mobile-wrap .close-mobile-nav:hover {
  cursor: pointer;
  color: #fff;
}

@media (max-width: 1200px) and (min-width: 768px) {
  .header-with-navigation-below .hidden-sm {
    display: none !important;
  }
  .header-with-navigation-below .visible-sm {
    display: block !important;
  }
  .header-with-navigation-below .mobile-dealer-logo .dealer-logo {
    max-height: 70px;
  }
}

@media (max-width: 767px) {
  .header-with-navigation-below .mobile-dealer-logo .dealer-logo {
    max-height: 55px;
  }
  .header-with-navigation-below .mobile-contact-bar {
    height: 55px;
  }
  .header-with-navigation-below .mobile-contact-bar .mobile-menu-toggle {
    height: 55px;
    padding: 15px;
    cursor: pointer;
  }
  .header-with-navigation-below .mobile-contact-bar .contact-info {
    margin-top: 3px;
    margin-right: 0;
  }
  .header-with-navigation-below .mobile-contact-bar .contact-info
    .contact-item {
    font-size: 35px;
  }
  .header-with-navigation-below .side-nav .open .dropdown-menu > li > a {
    padding: 0 25px 0 !important;
  }
}

@media (max-width: 480px) {
  .header-with-navigation-below .mobile-dealer-logo .dealer-logo {
    max-width: 230px;
  }
}

@media (max-width: 400px) {
  .header-with-navigation-below .mobile-dealer-logo .dealer-logo {
    max-width: 145px;
  }
}

  .dealer-logo {
  max-width: 320px;
  max-height: 85px;
  float: none;
  }
  .search-bar {
  margin: 0 auto;
  }
  .full-width-search-bar {
  padding: 10px;
  background: #ccc;
  }
  .contact-and-social {
  padding-right: 20px;
  }
  .search-bar .input-search, .search-bar button {
  height: 50px;
  font-size: 20px;
  }
  .search-bar .input-search {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .search-bar button {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
  .search-bar .toggleSearchText {
  font-size: 20px;
  }

  @media (min-width: 1200px) {
    .dealer-logo {
      max-height: 85px;
      display: block;
      margin: 0 auto 10px;
    }
  }

  @media (min-width: 768px) {
  .click-to-call, .mobile-directions {
  display: none;
  }
  .social-media-icons > a {
  float: right;
  text-align: right;
  }
  .navbar li.nav-dropdown ul li a {
  font-size: 15px;
  text-transform: inherit;
  }
  .nav > li > a {
  padding: 12px 10px;
  font-weight: 400;
  }
  header .search-bar {
  padding-top: 20px;
  }
  }

  @media (min-width: 768px) and (max-width: 1100px) {
  .navbar li {
  font-size: 11px;
  }
  .toggleSearchText {
  display: none;
  }
  }

  @media (max-width: 767px) {
  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {
  color: #333;
  }
  .dealer-logo {
  padding-bottom: 10px;
  max-height: 90px;
  display: block;
  }
  .toggleSearchText {
  display: none;
  }
  }

  .mobile-contact-bar {
  height: 70px;
  background: #fff;
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  }
  .mobile-contact-bar .mobile-dealer-logo img {
  padding: 10px;
  }
  .mobile-contact-bar .mobile-menu-toggle {
  width: 60px;
  height: 70px;
  padding: 25px 15px;
  float: left;
  background: transparent;
  cursor: pointer;
  }
  .mobile-contact-bar .mobile-menu-toggle .icon-bar {
  display: block;
  margin-top: 4px;
  width: 30px;
  height: 3px;
  border-radius: 1px;
  background-color: var(--primary-color);
  }
  .mobile-contact-bar .mobile-menu-toggle .icon-label {
  display: none;
  }
  .mobile-contact-bar .contact-info {
  float: right;
  margin-top: 1.6em;
  margin-right: 1.2em;
  }
  .mobile-contact-bar .contact-info .contact-item {
  display: inline-block;
  vertical-align: middle;
  color: var(--primary-color);
  font-size: 1.7em;
  letter-spacing: .05em;
  margin-right: .7em;
  }
  .mobile-contact-bar .contact-info .contact-item:hover {
  text-decoration: none;
  cursor: pointer;
  }
  .mobile-contact-bar .contact-info .contact-item .fa {
  margin-right: .1em;
  }
  .mobile-contact-bar .contact-info .contact-item a {
  color: inherit;
  }
  .mobile-contact-bar .contact-info .contact-item a:hover {
  text-decoration: inherit;
  }
  .mobile-nav-bar .side-nav {
  border-bottom: none;
  }
  .mobile-nav-bar .search-bar {
  border: 1px solid #4d4d4d;
  }
  .mobile-nav-bar .search-bar form {
  margin: 0;
  }
  .mobile-nav-bar .search-bar .input-search {
  margin: 0;
  height: 40px;
  }
  .mobile-nav-bar .search-bar .input-group-btn {
  padding: 0;
  }
  .mobile-nav-bar .search-bar .input-group-btn button {
  height: 40px;
  }
  .mobile-nav-bar .side-nav > li {
  display: block;
  float: left;
  width: 100%;
  border-bottom: 1px solid #333;
  }
  .mobile-nav-bar .side-nav > li > a, .mobile-nav-bar .navbar-inner > ul > li.dropdown > a {
  background: #222;
  color: #fff;
  display: block;
  height: 40px;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 15px;
  color: #fff;
  white-space: nowrap;
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  text-transform: none;
  margin: 0;
  }
  .mobile-nav-bar .side-nav > li > a:hover, .mobile-nav-bar .navbar-inner > ul > li.dropdown > a:hover {
  background: #1c1c1c;
  }
  .mobile-nav-bar .side-nav > li > ul {
  width: 100%;
  left: 0;
  position: relative;
  list-style: none;
  }
  .mobile-nav-bar .side-nav > li > ul > li > a {
  height: 40px;
  line-height: 40px;
  background: #444;
  font-size: 14px;
  color: #fff;
  text-align: left;
  float: left;
  min-width: 100%;
  position: relative;
  border-bottom: 1px solid #333;
  padding-left: 30px;
  }
  .mobile-nav-bar .side-nav > li > ul > li > a:hover {
  background: #333;
  }
  .mobile-nav-bar .close-mobile-wrap {
  text-align: right;
  padding: 10px 15px;
  }
  .mobile-nav-bar .close-mobile-wrap .close-mobile-nav {
  color: #aaa;
  }
  .mobile-nav-bar .close-mobile-wrap .close-mobile-nav:hover {
  cursor: pointer;
  color: #fff;
  }
  .sidr {
    position: absolute;
    z-index: 20;
    top: 70px;
    height: 100%;
    min-height: 600px;
    width: 260px;
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 15px;
    background: #333;
    color: #fff;
    box-shadow: 0 0 5px 5px #222 inset;
  }
  .sidr .input-search {
    width: 100%;
    font-size: 13px;
    padding: 5px;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 0 10px;
    border-radius: 2px;
    border: 0;
    background: rgba(0,0,0,0.1);
    color: rgba(255,255,255,0.6);
    clear: both;
  }
  .sidr ul {
    padding: 0;
    border-top: 1px solid #1a1a1a;
    border-bottom: 1px solid #4d4d4d;
    top: 100%;
    float: left;
    min-width: 160px;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,0.15);
    border-radius: 4px;
  }
  .sidr ul li {
    margin: 0;
    line-height: 48px;
    border-top: 1px solid #4d4d4d;
    border-bottom: 1px solid #1a1a1a;
  }

  @media (max-width: 767px) {
    .sidr {
      top: 55px;
    }
  }
</style>
